(function () {
    'use strict';
    var m = angular.module('dashboard');
    m.factory('policyInfoBoxesHelper', ["$q", "modals", "policiesRefreshHelper", "routeHelper", "$filter", "$parse", "odometerFormat", "linkedText", "escapeHtml", function ($q, modals, policiesRefreshHelper, routeHelper, $filter, $parse, odometerFormat, linkedText, escapeHtml) {
        var tagOnlyMode = false;
        var enabledModes = [
            'tag',
            'list'
        ];
        var goodColors = [
            '#2980b9',
            '#16a085',
            '#89b041',
            '#f39c12',
            '#f35428'
        ];
        var goodFontColors = [
            '#010a14',
            '#80858c',
            '#cc4125',
            '#16AA64',
            '#FEC543'
        ];
        var defaultSettings = {
            updateSec: 60,
            showType: 'match',
            period: 0,
            uparrow: 'green',
            rightMode: 'none',
            showType2: 'match'
        };
        var showTypes = [{
                id: 'match',
                label: 'Match',
                expression: 'Match'
            }    /* currently it's impossible to show anything, except match, but later it can return, so not removing now
     , {
     id: 'unmatch',
     label: 'Unmatch',
     expression: 'Unmatch',
     qs: {status: 'Unmatch'}
     }, {
     id: 'matchPercent',
     label: '% Match',
     expression: 'Match / total * 100',
     hideHistory: true
     }, {
     id: 'unmatchPercent',
     label: '% Unmatch',
     expression: 'Unmatch / total * 100',
     qs: {status: 'Unmatch'},
     hideHistory: true
     }, {
     id: 'pendingPercent',
     label: '% Pending',
     expression: 'Pending / total * 100',
     qs: {status: 'Pending'},
     hideHistory: true
     }*/];
        var showTypesMap = _(showTypes).chain().map(function (type) {
            return [
                type.id,
                type
            ];
        }).object().value();
        var periods = [
            {
                id: '1 hour',
                'label': '1 hour ago'
            },
            {
                id: '1 day',
                'label': '1 day ago'
            },
            {
                id: '7 day',
                'label': '7 days ago'
            },
            {
                id: '1 month',
                'label': '1 month ago'
            },
            {
                id: '3 month',
                'label': '3 months ago'
            },
            {
                id: '1 year',
                'label': '1 year ago'
            }
        ];
        var periodLabels = _(periods).chain().map(function (period) {
            return [
                period.id,
                period.label
            ];
        }).object().value();
        var historyTypes = _(showTypes).chain().filter(function (type) {
            return !type.hideHistory;
        }).pluck('id').value();
        var defaults;
        function toolTip(policies, showTypeId, showHistory, version) {
            var list = [];
            policiesRefreshHelper.addPolicies(_(policies).map(function (policy) {
                return policy.policy_id;
            }));
            _(policies).each(function (policy) {
                var info = policyInfoBoxesHelper.calculateNumbers(policy, showTypeId);
                info.policy_id = policy.policy_id;
                info.policy_name = policy.policy_name;
                list.push(info);
            });
            if (list.length < 1) {
                return;
            }
            return {
                content: {
                    text: '<div class="infobox-tooltip"><table>' + _(list).map(function (info, idx) {
                        var url = routeHelper.getHref('policy-edit', { id: info.policy_id }, showTypesMap[showTypeId].qs);
                        return '<tr>' + '<td><a href="' + url + '">' + escapeHtml(info.policy_name) + '</a></td>' + '<td>' + $filter('number')(info.value) + '</td>' + (showHistory ? '<td>' + (_(info.change).isUndefined() ? ' ' : info.change + '%') + '</td>' : '') + '</tr>';
                    }).join('') + '</table></div>'
                },
                position: {
                    at: 'bottom center',
                    my: 'top center',
                    viewport: true
                },
                hide: {
                    delay: 200,
                    fixed: true
                },
                style: { classes: version && version == 'v2' ? 'qtip-standard qtip-infobox' : 'qtip-bootstrap qtip-infobox' }
            };
        }
        var policyInfoBoxesHelper = {
            propertiesDialog: function (settings, options) {
                var policyVariants = options.policyVariants;
                var policyTags = options.policyTags;
                var titleModified = false;
                function modeOnChange(scope, newValue, oldValue) {
                    if (!titleModified) {
                        var titleParam = scope.findPageParamById('title');
                        if (titleParam) {
                            if (newValue !== settings.conf.mode) {
                                titleParam.data = '';
                            } else {
                                titleParam.data = settings.conf.title;
                            }
                        }
                    }
                }
                function titleOnChange(scope, newValue, oldValue) {
                    if (!titleModified) {
                        if (newValue !== '' && newValue !== settings.conf.title) {
                            titleModified = true;
                        }
                    }
                }
                var params = [
                    {
                        type: 'string',
                        id: 'title',
                        label: 'Title',
                        data: settings.conf.title,
                        onChange: titleOnChange
                    },
                    {
                        type: 'color',
                        id: 'color',
                        label: 'Color',
                        options: {
                            showPalette: true,
                            palette: _(goodColors).map(function (color) {
                                return [color];
                            })
                        },
                        data: settings.conf.color,
                        hidden: !options.showColorSelector
                    },
                    {
                        type: 'color',
                        id: 'fontColor',
                        label: 'Font Color',
                        options: {
                            showPalette: true,
                            palette: _(goodFontColors).map(function (color) {
                                return [color];
                            })
                        },
                        data: settings.conf.fontColor,
                        hidden: !options.showFontColorSelector
                    },
                    {
                        type: 'selector',
                        id: 'showType',
                        label: 'Show',
                        variants: showTypes,
                        data: settings.conf.showType,
                        validation: { required: true }
                    },
                    {
                        type: 'string',
                        id: 'valueTitle',
                        label: 'Value description',
                        data: settings.conf.valueTitle
                    },
                    {
                        type: 'radio-group',
                        id: 'mode',
                        label: 'Query fetch mode',
                        buttons: [
                            {
                                value: 'policy',
                                label: 'Single Query'
                            },
                            {
                                value: 'tag',
                                label: 'By Tag'
                            },
                            {
                                value: 'list',
                                label: 'By Queries'
                            }
                        ],
                        data: settings.conf.mode || enabledModes && enabledModes.length && enabledModes[0] || 'policy',
                        onChange: modeOnChange
                    },
                    {
                        type: 'list',
                        id: 'policyId',
                        label: 'Query',
                        variants: policyVariants,
                        data: settings.conf.policyId,
                        settings: { multiple: false },
                        validation: { required: true },
                        enabled: [{
                                param: 'mode',
                                equal: 'policy'
                            }]
                    },
                    {
                        type: 'string',
                        id: 'tag',
                        label: 'Query Tag',
                        data: settings.conf.tag,
                        variants: policyTags,
                        validation: { required: true },
                        enabled: [{
                                param: 'mode',
                                equal: 'tag'
                            }]
                    },
                    {
                        type: 'list',
                        id: 'policies',
                        label: 'Choose queries',
                        variants: policyVariants,
                        data: settings.conf.policies,
                        validation: { required: true },
                        enabled: [{
                                param: 'mode',
                                equal: 'list'
                            }]
                    },
                    {
                        type: 'radio-group',
                        id: 'rightMode',
                        label: 'Right value',
                        buttons: [
                            {
                                value: 'none',
                                label: 'none'
                            },
                            {
                                value: 'history',
                                label: 'History'
                            },
                            {
                                value: 'value',
                                label: 'Another value'
                            }
                        ],
                        paramClass: 'radio-group-inline',
                        data: settings.conf.rightMode || 'none'
                    },
                    {
                        type: 'selector',
                        id: 'period',
                        label: 'Show change with data',
                        variants: periods,
                        data: settings.conf.period,
                        enabled: [
                            {
                                param: 'showType',
                                'in': historyTypes
                            },
                            {
                                param: 'rightMode',
                                'equal': 'history'
                            }
                        ]
                    },
                    {
                        type: 'radio-group',
                        id: 'uparrow',
                        label: 'Change arrows colors',
                        enabled: [
                            {
                                param: 'showType',
                                'in': historyTypes
                            },
                            {
                                param: 'rightMode',
                                'equal': 'history'
                            }
                        ],
                        buttons: [
                            {
                                value: 'green',
                                label: '#' + JSON.stringify({
                                    text: '<span class="infobox-trend-arrows"><span class="fa fa-long-arrow-up"></span><span class="fa fa-long-arrow-down"></span></span>',
                                    display: 'html'
                                })
                            },
                            {
                                value: 'red',
                                label: '#' + JSON.stringify({
                                    text: '<span class="infobox-trend-arrows uparrow-red"><span class="fa fa-long-arrow-up"></span><span class="fa fa-long-arrow-down"></span></span>',
                                    display: 'html'
                                })
                            }
                        ],
                        paramClass: 'radio-group-inline infobox-param-arrows',
                        data: settings.conf.uparrow
                    },
                    {
                        type: 'selector',
                        id: 'showType2',
                        label: 'Right Value Show Type',
                        variants: showTypes,
                        data: settings.conf.showType2,
                        validation: { required: true },
                        enabled: [{
                                param: 'rightMode',
                                'equal': 'value'
                            }]
                    },
                    {
                        type: 'string',
                        id: 'valueTitle2',
                        label: 'Right Value description',
                        data: settings.conf.valueTitle2,
                        enabled: [{
                                param: 'rightMode',
                                'equal': 'value'
                            }]
                    },
                    {
                        type: 'radio-group',
                        id: 'mode2',
                        label: 'Right Value Fetch Mode',
                        buttons: [
                            {
                                value: 'policy',
                                label: 'Single Query'
                            },
                            {
                                value: 'tag',
                                label: 'By Tag'
                            },
                            {
                                value: 'list',
                                label: 'By Queries'
                            }
                        ],
                        data: settings.conf.mode2 || enabledModes && enabledModes.length && enabledModes[0] || 'policy',
                        enabled: [{
                                param: 'rightMode',
                                'equal': 'value'
                            }]
                    },
                    {
                        type: 'list',
                        id: 'policyId2',
                        label: 'Right Value Query',
                        variants: policyVariants,
                        data: settings.conf.policyId2,
                        settings: { multiple: false },
                        validation: { required: true },
                        enabled: [
                            {
                                param: 'mode2',
                                equal: 'policy'
                            },
                            {
                                param: 'rightMode',
                                'equal': 'value'
                            }
                        ]
                    },
                    {
                        type: 'string',
                        id: 'tag2',
                        label: 'Right Value Query Tag',
                        data: settings.conf.tag2,
                        variants: policyTags,
                        validation: { required: true },
                        enabled: [
                            {
                                param: 'mode2',
                                equal: 'tag'
                            },
                            {
                                param: 'rightMode',
                                'equal': 'value'
                            }
                        ]
                    },
                    {
                        type: 'list',
                        id: 'policies2',
                        label: 'Right Value Queries',
                        variants: policyVariants,
                        data: settings.conf.policies2,
                        validation: { required: true },
                        enabled: [
                            {
                                param: 'mode2',
                                equal: 'list'
                            },
                            {
                                param: 'rightMode',
                                'equal': 'value'
                            }
                        ]
                    }
                ];
                if (tagOnlyMode) {
                    //This code is out-dated now. Update it if tagOnlyMode is required (processing of mode2 and showtypes should be added)
                    params = _(params).filter(function (param) {
                        if (param.id === 'mode' || param.enabled && param.enabled.param === 'mode' && param.enabled.equal !== 'tag') {
                            return false;
                        }
                        if (param.enabled && param.enabled.param === 'mode') {
                            delete param.enabled;
                        }
                        return true;
                    });
                } else {
                    params = _(params).filter(function (param) {
                        if (param.id === 'mode' && enabledModes.length < 2 || param.id === 'mode2' && enabledModes.length < 2) {
                            return false;
                        }
                        if (param.id === 'mode' || param.id === 'mode2') {
                            param.buttons = _(param.buttons).filter(function (button) {
                                return _(enabledModes).contains(button.value);
                            });
                        }
                        if (showTypes.length === 1 && param.variants === showTypes) {
                            return false;
                        }
                        if (param.enabled) {
                            var modeParam = _(param.enabled).find(function (param) {
                                return param.param === 'mode' || param.param === 'mode2';
                            });
                            if (modeParam && !_(enabledModes).contains(modeParam.equal)) {
                                return false;
                            }
                            if (enabledModes.length < 2 && modeParam) {
                                param.enabled = _(param.enabled).filter(function (param) {
                                    return param.param !== 'mode' && param.param !== 'mode2';
                                });
                                if (!param.enabled.length) {
                                    delete param.enabled;
                                }
                            }
                        }
                        return true;
                    });
                }
                return modals.params([{
                        lastPage: true,
                        okButton: 'Save',
                        params: params,
                        buttons: options.buttons
                    }], 'Configure infobox', null, { bodyClass: 'policy-infobox-config-modal' }).then(function (data) {
                    if (tagOnlyMode) {
                        data.mode = 'tag';
                    }
                    if (data.rightMode !== 'history') {
                        data.period = 0;
                    }
                    if (showTypes.length === 1) {
                        data.showType = showTypes[0].id;
                        data.showType2 = showTypes[0].id;
                    }
                    return data;
                });
            },
            processSettings: function (id, settings, options) {
                var policy;
                var widgetTitle;
                var setDefault = true;
                var defaultTitle = '';
                var policyVariants = options.policyVariants;
                var defaultColor = options.defaultColor;
                var defaultFontColor = options.defaultFontColor;
                if (settings) {
                    switch (settings.conf.mode) {
                    case 'list':
                        if (settings.conf.policies && settings.conf.policies.length) {
                            policy = _(policyVariants).find(function (variant) {
                                return _(settings.conf.policies).contains(variant.id);
                            });
                            if (policy) {
                                setDefault = false;
                                defaultTitle = policy.label;
                            }
                        }
                        break;
                    case 'tag':
                        defaultTitle = 'Queries by tag total';
                        setDefault = false;
                        break;
                    default:
                        if (settings.conf.policyId) {
                            policy = _(policyVariants).find(function (variant) {
                                return variant.id === settings.conf.policyId;
                            });
                            if (policy) {
                                setDefault = false;
                                defaultTitle = policy.label;
                            }
                        }
                    }
                }
                if (setDefault) {
                    settings = {
                        conf: $.extend({}, defaultSettings),
                        id: id
                    };
                    widgetTitle = options.noDefaultTitle ? '' : 'Click to configure';
                } else {
                    _(settings.conf).defaults(defaultSettings);
                    widgetTitle = settings.conf.title || !options.noDefaultTitle && defaultTitle || '';
                    if (_(showTypes).chain().find(function (type) {
                            return type.id === settings.conf.showType;
                        }).isUndefined().value()) {
                        settings.conf.showType = showTypes[0].id;
                    }
                }
                if (defaultColor && !/#[0-9a-fA-F]{6}/.test(settings.conf.color)) {
                    settings.conf.color = defaultColor;
                }
                if (defaultFontColor && !/#[0-9a-fA-F]{6}/.test(settings.conf.fontColor)) {
                    settings.conf.fontColor = defaultFontColor;
                }
                settings.widgetTitle = widgetTitle;
                if (settings.conf.rightMode !== 'value') {
                    if (_(periods).find(function (period) {
                            return period.id === settings.conf.period;
                        })) {
                        settings.conf.rightMode = 'history';
                    } else {
                        settings.conf.rightMode = 'none';
                    }
                }
                if (!_(periods).find(function (period) {
                        return period.id === settings.conf.period;
                    })) {
                    settings.conf.period = periods[0].id;
                }
                if (settings.conf.rightMode === 'value') {
                    var resetRight = true;
                    switch (settings.conf.mode2) {
                    case 'list':
                        if (settings.conf.policies2 && settings.conf.policies2.length) {
                            policy = _(policyVariants).find(function (variant) {
                                return _(settings.conf.policies2).contains(variant.id);
                            });
                            if (policy) {
                                resetRight = false;
                            }
                        }
                        break;
                    case 'tag':
                        resetRight = false;
                        break;
                    default:
                        if (settings.conf.policyId2) {
                            policy = _(policyVariants).find(function (variant) {
                                return variant.id === settings.conf.policyId2;
                            });
                            if (policy) {
                                resetRight = false;
                            }
                        }
                    }
                    if (resetRight) {
                        settings.conf.rightMode = 'none';
                    }
                }
                return settings;
            },
            goodColors: goodColors,
            goodFontColors: goodFontColors,
            showTypes: showTypes,
            periods: periods,
            calculateNumbers: function (data, showTypeId) {
                var expression = showTypesMap[showTypeId].expression;
                var res = { value: Math.round($parse(expression)(data.findings)) };
                if (data.history && !_(data.history.total).isUndefined()) {
                    var historyValue = Math.round($parse(expression)(data.history));
                    res.change = 0;
                    if (res.value == historyValue) {
                        return res;
                    }
                    if (historyValue === 0) {
                        res.change = '>999';
                        return res;
                    }
                    res.change = Math.round((res.value - historyValue) / historyValue * 100);
                    if (res.change > 999) {
                        res.change = '>999';
                        return res;
                    }
                    if (res.change > 0) {
                        res.change = '+' + res.change;
                    }
                }
                return res;
            },
            formatCount: function (numbers, mode, policies, policyId, showTypeId, showHistory, emptyNaN, version) {
                if (emptyNaN) {
                    return {
                        text: '',
                        display: 'text'
                    };
                }
                var showType = showTypesMap[showTypeId];
                var mainCount;
                if (mode !== 'policy') {
                    mainCount = linkedText.toParts(odometerFormat(numbers.value));
                    _(mainCount).each(function (item) {
                        item.tooltip = toolTip(policies, showTypeId, showHistory, version);
                        item.text = item.data.text;
                        item.odometer = item.data.odometer;
                        if (policies && policies.length === 1) {
                            item.clickEvent = {
                                name: 'open-policy',
                                id: policies[0].policy_id,
                                qs: showType.qs,
                                type: 'policy-edit'
                            };
                            item.class = { 'clickable': true };
                        }
                    });
                } else {
                    mainCount = {
                        text: numbers.value,
                        odometer: {
                            duration: 10000,
                            format: '(,ddd)'
                        },
                        clickEvent: {
                            name: 'open-policy',
                            id: policyId,
                            qs: showType.qs
                        }
                    };
                }
                return mainCount;
            },
            makeDisplayData: function (data, settings, version) {
                var result = {
                    leftMessageText: settings.valueTitle || '',
                    rightMessageText: '',
                    leftCount: {
                        display: 'text',
                        text: ''
                    },
                    rightCount: {
                        display: 'text',
                        text: ''
                    }
                };
                var mainNumbers = policyInfoBoxesHelper.calculateNumbers(data, settings.showType);
                result.rightCount = {
                    display: 'text',
                    text: ''
                };
                result.rightMessageText = '';
                var showHistoryOnTooltip = false;
                if (settings.rightMode === 'history' && settings.period) {
                    if (_(mainNumbers.change).isUndefined()) {
                        result.rightMessageText = 'History not available';
                    } else {
                        var historyArrow = '';
                        if (mainNumbers.change !== 0) {
                            if (mainNumbers.change < 0) {
                                historyArrow = '<span class="fa fa-long-arrow-down"></span>';
                            } else {
                                historyArrow = '<span class="fa fa-long-arrow-up"></span>';
                            }
                        }
                        result.rightCount = {
                            text: historyArrow + mainNumbers.change + '%',
                            display: 'html'
                        };
                        result.rightMessageText = 'Change since ' + periodLabels[settings.period];
                        showHistoryOnTooltip = true;
                    }
                }
                if (settings.rightMode === 'value') {
                    var rightNumbers = policyInfoBoxesHelper.calculateNumbers(data.rightData, settings.showType2);
                    result.rightCount = policyInfoBoxesHelper.formatCount(rightNumbers, settings.mode2, data.rightData.policies, settings.policyId2, settings.showType2, false, null, version);
                    result.rightMessageText = settings.valueTitle2 || '';
                }
                result.leftCount = policyInfoBoxesHelper.formatCount(mainNumbers, settings.mode, data.policies, settings.policyId, settings.showType, showHistoryOnTooltip, null, version);
                return result;
            }
        };
        return policyInfoBoxesHelper;
    }]);
}());